<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink">
<p class="center "><span class="smallcaps">FOR BILL AND MARGARET</span><br/>
<span class="smallcaps">AND FOR DON</span></p>
</blockquote>
<div class="timebreak "> </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?3dece3ae